import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Colors from '../colors';
import MembersList from '../components/AttendanceSheet/MembersList';
import styles from '../components/AttendanceSheet/styles.module.css';
import NavTabs from '../components/NavTabs';
import PlusIconButton from '../components/PlusIconButton';
import SearchBar from '../components/SearchBar';
import AddMemberModal from '../components/modals/AddMemberModal';
import OutlineButton from '../components/modals/Buttons/outline/OutlinedModalButton';
import ConfirmationModal from '../components/modals/ConfirmationModal';
import { createNewSubcollectionDocInDb, deleteDocInSubCollection, getAllDocsBySubCollection, updateDocInSubCollection, getDocByCollectionAndId } from '../firebase';
import { Snackbar, Alert } from '@mui/material';
import EncourageCreation from '../components/EncourageCreation';

function Attendance({ user }) {
  const [members, setMembers] = useState([])
  const [search, setSearch] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [filteredMembers, setFilteredMembers] = useState(members);
  const [isVisible, setIsVisible] = useState(false)
  const [firstName, setFirstNameText] = useState('')
  const [lastName, setLastNameText] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [notes, setNotes] = useState('')
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const [isArchived, setIsArchived] = useState(true);
  const [errorMessage, setErrorMessage] = useState('(0) Attendees found.')
  const [isCheckinDisabled, setIsCheckinDisabled] = useState(false);
  const [isCheckoutDisabled, setIsCheckoutDisabled] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  let { formId } = useParams();

  useEffect(() => {
    setFirstNameText('');
    setLastNameText('');
    setPhoneNumber('');
    setNotes('');
  }, [isVisible]);

  useEffect(() => {
    if (!user) return;
    const getform = async () => {
      const form = await getDocByCollectionAndId("Forms", formId);
      setIsArchived(form.isArchived || form.userId !== user.uid);
      if (form.isArchived || form.userId !== user.uid) setSnackbarOpen(true);
    }
    getform()
    const getMembers = async () => {
      const updatedMembers = await getAllDocsBySubCollection('Forms', formId, 'FormMembers');
      setMembers(updatedMembers);
    };
    getMembers();
  }, [formId, user]);

  useEffect(() => {
    const filtered = members
      .filter((member) => {
        const fullName = `${member.firstName} ${member.lastName}`;
        return fullName.toLowerCase().includes(search.toLowerCase()) || setErrorMessage("(0) Attendees match your search.");
      }).filter((member) => {
        if (value === 0) {
          const uncheckedStudents = members.filter((student) => student.checkin === false);
          const checkedInStudents = members.filter((student) => student.checkin === true);
          const checkedOutStudents = members.filter((student) => student.checkout === true);
          const sortedMembers = uncheckedStudents.concat(checkedInStudents, checkedOutStudents);
          return sortedMembers.length > 0 ? sortedMembers : setErrorMessage('(0) Attendees found.');
        } else if (value === 1) {
          return (member.checkin === true && member.checkout === false) || setErrorMessage('(0) Attendees currently checked in.');
        } else {
          return member.checkout === true || setErrorMessage('(0) Attendees currently checked out.');
        }
      });
    filtered.sort((a, b) => {
      if (a.firstName < b.firstName) {
        return -1;
      } else if (a.firstName > b.firstName) {
        return 1;
      } else {
        return 0;
      }
    });
    setFilteredMembers(filtered);
  }, [search, value, members]);

  useEffect(() => {
    const isEveryMemberCheckedIn = members.every((member) => member.checkin);
    if (isArchived || isEveryMemberCheckedIn) {
      setIsCheckinDisabled(true);
    } else {
      setIsCheckinDisabled(false)
    }
    const isEveryMemberCheckedOut = members.every((member) => member.checkout);
    if (isArchived || isEveryMemberCheckedOut) {
      setIsCheckoutDisabled(true);
    } else {
      setIsCheckoutDisabled(false);
    }
  }, [members, isArchived]);

  const updateMemberDB = async (member) => {
    await updateDocInSubCollection('Forms', formId, 'FormMembers', member.id, {
      checkin: member.checkin,
      checkout: member.checkout,
      checkinTime: member.checkinTime,
      checkoutTime: member.checkoutTime,
      phoneNumber: member?.phoneNumber,
      notes: member.notes,
      equipment: member.equipment
    });
  };

  const updateMember = (updatedMember) => {
    const index = members.findIndex(
      (s) => s.id === updatedMember.id
    );
    if (index !== -1) {
      const updatedMembers = [
        ...members.slice(0, index),
        updatedMember,
        ...members.slice(index + 1),
      ];
      updateMemberDB(updatedMember)
      setMembers(updatedMembers);
    }
  };

  const deleteMemberDB = async (member) => {
    const index = members.findIndex(
      (s) => s.id === member.id
    );
    if (index !== -1) {
      await deleteDocInSubCollection('Forms', formId, 'FormMembers', member.id);
      const updatedMembers = members.filter(s => s.id !== member.id);
      setMembers(updatedMembers);
    }
  };

  const addMember = async () => {
    const memberData = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      phoneNumber,
      checkin: false,
      checkout: false,
      checkinTime: null,
      checkoutTime: null,
      notes: notes.trim(),
      equipment: '',
    };
    const newMember = await createNewSubcollectionDocInDb('Forms', formId, 'FormMembers', memberData);
    setMembers(prevMembers => [...prevMembers, newMember]);
    setIsVisible(false);
  };


  const handleCheckInAll = () => {
    const now = new Date().toLocaleTimeString();
    const updatedMembers = members.map((member) => {
      if (!member.checkin) {
        return {
          ...member,
          checkin: true,
          checkinTime: now,
        };
      } else {
        return member;
      }
    });
    updatedMembers?.forEach(async (member) => {
      updateMember(member);
    });
    setMembers(updatedMembers);
    setOpen(false)
  };

  const handleCheckOutAll = () => {
    const now = new Date().toLocaleTimeString();
    const updatedMembers = members.map((member) => {
      if (member.checkin && !member.checkout) {
        return {
          ...member,
          checkout: true,
          checkoutTime: now,
        };
      } else {
        return member;
      }
    });
    updatedMembers?.forEach(async (member) => {
      updateMember(member);
    });
    setMembers(updatedMembers);
    setOpen1(false)
  };

  return (
    <div className={styles.attendance}>
      <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ marginTop: '50px' }}>
        <Alert severity="info" sx={{ width: '100%' }}>
          This attendance sheet is archived or you do not have permission to edit it.
        </Alert>
      </Snackbar>
      <SearchBar placeholder="Search by Name" search={search} setSearch={setSearch}></SearchBar>
      <div style={{ width: '100%', marginRight: 'auto' }}>
        <Typography style={{ fontFamily: 'Jost', fontWeight: 'bold', fontSize: '1.4rem', }}>Attendees</Typography>
        <Divider />
      </div>
      <div style={{ width: '100%' }}>
        <NavTabs className={styles.tabs} value={value} setValue={setValue} tabTitles={["All", "Checked In", "Checked Out"]} style={{ fontSize: 'min(3.5vw, 16px)' }} />
      </div>
      <div className={styles.buttonContainer}>
        {<OutlineButton color={Colors.green} label={"Check In All"} onClick={handleOpen} style={{ fontSize: '17px' }}
          disabled={isCheckinDisabled} />}
        {<OutlineButton color={Colors.orange} label={"Check Out All"} onClick={handleOpen1} style={{ fontSize: '17px' }}
          disabled={isCheckoutDisabled} />}
      </div>

      {filteredMembers.length > 0 && <div className={styles.membersContainer}>
        {filteredMembers?.map((member, index) => (
          <MembersList
            key={index}
            member={member}
            updateMember={updateMember}
            deleteMemberDB={deleteMemberDB}
            isArchived={isArchived}
          />
        ))}
      </div>}
      {!isArchived &&
        <Box sx={{ position: 'fixed', bottom: '20px', right: '20px' }} >
          <PlusIconButton color={Colors.green} onClick={() => setIsVisible(true)} />
        </Box>
      }
      {isVisible && <AddMemberModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        firstName={firstName}
        lastName={lastName}
        phoneNumber={phoneNumber}
        setNotesText={setNotes}
        setFirstNameText={setFirstNameText}
        setLastNameText={setLastNameText}
        setHealthInfoText={setNotes}
        setPhoneNumText={setPhoneNumber}
        onClickAddMember={addMember}
      />}
      {open && <ConfirmationModal
        isVisible={open}
        setIsVisible={setOpen}
        title={"Check in all Members?"}
        mainAction={"Yes"}
        mainActionHandler={handleCheckInAll} />}
      {open1 && <ConfirmationModal
        isVisible={open1}
        setIsVisible={setOpen1}
        title={"Check out all Members?"}
        mainAction={"Yes"}
        mainActionHandler={handleCheckOutAll} />}
      {members.length === 0 && <EncourageCreation headerText={errorMessage} suggestionText={'Tap the plus icon to add an Attendee.'} />}
      {(members.length > 0 && filteredMembers.length === 0) && <EncourageCreation headerText={errorMessage} />}
    </div>
  );
}
export default Attendance;
